import * as React from "react";
// Controls
import { getButtons, KnownRibbonButtonKey, Ribbon } from "roosterjs-react/lib-mjs";
// Utilities
import { useTheme } from "@fluentui/react";
import { css, getRTL } from "@fluentui/utilities";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
import { getClassNames, getStyles } from "./RichTextEditorRibbon.styles";
const defaultRibbonButtonKeys = [
    KnownRibbonButtonKey.Bold,
    KnownRibbonButtonKey.Italic,
    KnownRibbonButtonKey.Underline,
    KnownRibbonButtonKey.Strikethrough,
    KnownRibbonButtonKey.TextColor,
    KnownRibbonButtonKey.FontSize,
    KnownRibbonButtonKey.ClearFormat,
    KnownRibbonButtonKey.BulletedList,
    KnownRibbonButtonKey.RemoveLink,
    KnownRibbonButtonKey.DecreaseIndent,
    KnownRibbonButtonKey.IncreaseIndent,
    KnownRibbonButtonKey.InsertTable,
    KnownRibbonButtonKey.Undo,
    KnownRibbonButtonKey.Redo
];
export function RichTextEditorRibbon(props) {
    const theme = useTheme();
    const { buttonKeys = defaultRibbonButtonKeys, customizedButtons } = props;
    const styles = getStyles(theme, props.styles);
    const classNames = getClassNames(styles);
    const localizedStrings = {
        buttonNameBold: Strings.TaskEditor_ButtonNameBold,
        buttonNameItalic: Strings.TaskEditor_ButtonNameItalic,
        buttonNameUnderline: Strings.TaskEditor_ButtonNameUnderline,
        buttonNameStrikethrough: Strings.TaskEditor_ButtonNameStrikethrough,
        buttonNameBackgroundColor: Strings.TaskEditor_ButtonNameBackgroundColor,
        buttonNameTextColor: Strings.TaskEditor_ButtonNameTextColor,
        buttonNameFontSize: Strings.TaskEditor_ButtonNameFontSize,
        buttonNameClearFormat: Strings.TaskEditor_ButtonNameClearFormat,
        buttonNameBulletedList: Strings.TaskEditor_ButtonNameBulletedList,
        buttonNameNumberedList: Strings.TaskEditor_ButtonNameNumberedList,
        buttonNameCode: Strings.TaskEditor_ButtonNameCode,
        buttonNameQuote: Strings.TaskEditor_ButtonNameQuote,
        buttonNameInsertLink: Strings.TaskEditor_ButtonNameInsertLink,
        buttonNameRemoveLink: Strings.TaskEditor_ButtonNameRemoveLink,
        buttonNameDecreaseIndent: Strings.TaskEditor_ButtonNameDecreaseIndent,
        buttonNameInsertTable: Strings.TaskEditor_ButtonNameInsertTable,
        buttonNameUndo: Strings.TaskEditor_ButtonNameUndo,
        buttonNameRedo: Strings.TaskEditor_ButtonNameRedo,
        buttonNameOK: Strings.SharedComponents_ButtonNameOK,
        buttonNameCancel: Strings.TaskEditor_ButtonNameCancel,
        insertLinkDialogUrl: Strings.TaskEditor_insertLinkDialogUrl,
        insertLinkDialogDisplayAs: Strings.TaskEditor_insertLinkDialogDisplayAs,
        fontSizeSmall: Strings.TaskEditor_FontSizeSmall,
        fontSizeMedium: Strings.TaskEditor_FontSizeMedium,
        fontSizeLarge: Strings.TaskEditor_FontSizeLarge,
        backgroundColorWhite: Strings.TaskEditor_BackgroundColorWhite,
        backgroundColorKobiRed: Strings.TaskEditor_BackgroundColorKobiRed,
        backgroundColorRoseBud: Strings.TaskEditor_BackgroundColorRoseBud,
        backgroundColorGoldenrod: Strings.TaskEditor_BackgroundColorGoldenrod,
        backgroundColorPrimrose: Strings.TaskEditor_BackgroundColorPrimrose,
        backgroundColorMantis: Strings.TaskEditor_BackgroundColorMantis,
        backgroundColorRegentBlue: Strings.TaskEditor_BackgroundColorRegentBlue,
        backgroundColorPeriwinkleGray: Strings.TaskEditor_BackgroundColorPeriwinkleGray,
        backgroundColorPaleRose: Strings.TaskEditor_BackgroundColorPaleRose
    };
    const mainWindowButtons = getButtons(buttonKeys).map((button)=>{
        // Check if there's a custom button with the same key
        const customButton = customizedButtons?.find((cb)=>cb.key === button.key);
        const buttonToUse = {
            ...customButton ?? button
        };
        if (buttonToUse.dropDownMenu) {
            buttonToUse.dropDownMenu.itemClassName = css(buttonToUse.dropDownMenu.itemClassName || "", classNames.ribbonButtonDropDown);
            if (buttonToUse.dropDownMenu.commandBarSubMenuProperties) {
                buttonToUse.dropDownMenu.commandBarSubMenuProperties.className = css(buttonToUse.dropDownMenu.commandBarSubMenuProperties.className || "", classNames.ribbonButtonSubMenu);
            }
        }
        if (buttonToUse.isChecked != null) {
            buttonToUse.commandBarProperties = {
                ...buttonToUse.commandBarProperties || {},
                // The CommandBar renders its primary items inside a role="menubar". By default each item gets role="menuitem",
                // which is incompatible with aria-pressed. For buttons that behave as toggles (e.g. Bold, Italic, Bulleted list),
                // set role="menuitemcheckbox" so Fluent's button emits the correct aria-checked attribute instead of aria-pressed.
                role: "menuitemcheckbox"
            };
        }
        return buttonToUse;
    });
    return /*#__PURE__*/ React.createElement(Ribbon, {
        strings: localizedStrings,
        buttons: mainWindowButtons,
        dir: getRTL() ? "rtl" : "ltr",
        className: classNames.root,
        overflowButtonProps: {
            menuProps: {
                items: [],
                className: classNames.ribbonOverflowButton
            }
        },
        ...props
    });
}
